import React, { useContext } from "react";
import { WishListContext } from "../context/WishListProvider"; // Ensure path is correct
import { CartContext } from "../context/CartProvider"; // Ensure path is correct
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { FaEye, FaCartPlus, FaHeartBroken, FaShoppingBag } from "react-icons/fa"; // Using FaCartPlus
import { FiTrash2, FiArrowRight } from "react-icons/fi"; // For delete and continue shopping

const WishListPage = () => {
  const { getWishList, removeWishList } = useContext(WishListContext);
  const { addToCart } = useContext(CartContext);
  const wishList = getWishList() || []; // Ensure wishList is always an array

  const primaryAccentColor = "#e5272e"; // Red from gradient
  const gradientColor = "linear-gradient(to right, #e5272e, #f59332)";

  const handleAddToCartAndRemove = (item) => {
    addToCart(item); // Add to cart
    removeWishList(item.product_id || item.id); // Remove from wishlist
    toast.success(`${item.product_name} moved to cart!`);
  };

  const handleRemoveFromWishlist = (itemId, itemName) => {
    removeWishList(itemId);
    toast.success(`${itemName} removed from wishlist.`);
  };

  // Helper to get the correct price, prioritizing selectedAttributes
  const getDisplayPrice = (item) => {
    const regularPrice = parseFloat(item.selectedAttributes?.price || item.reguler_price || item.price || 0);
    const discountPrice = parseFloat(item.selectedAttributes?.discount_price || item.discount_price || regularPrice);
    return { regularPrice, discountPrice };
  };


  return (
    <>
      <style>
        {`
          .wishlist-page-container {
            background-color: #ffffff;
            min-height: 80vh;
          }
          .wishlist-header {
             padding: 60px 0 40px;
             text-align: center;
          }
          .wishlist-title {
            color: #1a1a1a;
            font-weight: 800;
            font-size: 2.75rem;
            letter-spacing: -0.03em;
            margin-bottom: 10px;
          }
          .wishlist-subtitle {
            color: #666;
            font-size: 1.1rem;
          }
          .wishlist-empty-card {
            background-color: #fff;
            padding: 4rem 2rem;
            border-radius: 24px;
            box-shadow: 0 10px 40px rgba(0,0,0,0.04);
            border: 1px solid #f0f0f0;
          }
          .wishlist-empty-card svg {
            color: ${primaryAccentColor};
            margin-bottom: 25px;
            filter: drop-shadow(0 10px 15px rgba(229, 39, 46, 0.2));
          }
          .btn-start-shopping {
            background: #d93a38;
            color: white;
            border: none;
            padding: 12px 30px;
            border-radius: 12px;
            font-weight: 700;
            transition: all 0.3s ease;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            gap: 10px;
          }
          .btn-start-shopping:hover {
            background: #b72f2d;
            color: white;
            transform: translateY(-3px);
            box-shadow: 0 10px 20px rgba(217, 58, 56, 0.2);
          }
          .wishlist-item-card {
            border: 1px solid #f0f0f0 !important;
            border-radius: 20px !important;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            overflow: hidden;
            background: #fff;
          }
          .wishlist-item-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(0,0,0,0.06);
            border-color: #eee !important;
          }
          .wishlist-img-wrapper {
            position: relative;
            background: #fdfdfd;
            padding: 20px;
            height: 240px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
          }
          .wishlist-item-card .card-img-top {
            max-height: 100%;
            width: auto;
            max-width: 100%;
            object-fit: contain;
            transition: transform 0.6s ease;
          }
          .wishlist-item-card:hover .card-img-top {
            transform: scale(1.1);
          }
          .wishlist-badge {
            position: absolute;
            top: 15px;
            left: 15px;
            background: #d93a38;
            color: white;
            padding: 4px 10px;
            border-radius: 50px;
            font-size: 0.7rem;
            font-weight: 800;
            text-transform: uppercase;
            z-index: 2;
          }
          .wishlist-item-card .card-body {
            padding: 20px;
            display: flex;
            flex-direction: column;
          }
          .wishlist-item-card .card-title {
            font-size: 1.1rem;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 8px;
            height: 2.6em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            line-height: 1.3;
          }
          .wishlist-price-section {
            margin-bottom: 20px;
          }
          .wishlist-price-section .discounted-price {
            font-size: 1.4rem;
            font-weight: 800;
            color: #1a1a1a;
          }
          .wishlist-price-section .original-price {
            font-size: 0.95rem;
            color: #999;
            margin-right: 10px;
          }
          .wishlist-actions {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
          }
          .btn-wishlist-main {
            padding: 10px;
            border-radius: 12px;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            font-size: 0.85rem;
            transition: all 0.3s ease;
            border: 1px solid #f0f0f0;
          }
          .btn-details-wishlist {
            background: white;
            color: #1a1a1a;
          }
          .btn-details-wishlist:hover {
            border-color: #1a1a1a;
            background: #fdfdfd;
          }
          .btn-addtocart-wishlist {
            background: #d93a38;
            color: white;
            border: none;
          }
          .btn-addtocart-wishlist:hover {
            background: #b72f2d;
            transform: translateY(-2px);
          }
          .btn-remove-wishlist {
            position: absolute;
            top: 15px;
            right: 15px;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: white;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ff4d4d;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
            border: none;
            z-index: 3;
            transition: all 0.3s ease;
          }
          .btn-remove-wishlist:hover {
            background: #ff4d4d;
            color: white;
            transform: rotate(90deg);
          }
        `}
      </style>
      <div className="container pb-5 wishlist-page-container">
        <header className="wishlist-header">
          <h1 className="wishlist-title">My Wishlist</h1>
          <p className="wishlist-subtitle">Items you've saved to explore later</p>
        </header>

        {wishList.length === 0 ? (
          <div className="row justify-content-center mt-4">
            <div className="col-md-8 col-lg-6">
              <div className="text-center wishlist-empty-card">
                <FaHeartBroken size={70} />
                <h4 className="fw-bold mb-3">Your Wishlist is Empty</h4>
                <p className="text-muted mb-4 px-lg-5">
                  Seems like you haven't added anything yet. Start exploring our premium collection and cave your favorites!
                </p>
                <Link to="/shop" className="btn btn-start-shopping">
                  <FaShoppingBag />
                  Explore Collection
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className="row g-4 mt-2">
            {wishList.map((item) => {
              const { regularPrice, discountPrice } = getDisplayPrice(item);
              const hasDiscount = discountPrice < regularPrice;

              return (
                <div className="col-sm-6 col-md-4 col-lg-3" key={item.product_id || item.id}>
                  <div className="card h-100 wishlist-item-card border-0">
                    <button
                      className="btn-remove-wishlist"
                      onClick={() => handleRemoveFromWishlist(item.product_id || item.id, item.product_name)}
                      title="Remove from Wishlist"
                    >
                      <FiTrash2 size={16} />
                    </button>

                    <Link to={`/product_details/${item.product_id || item.id}`} className="wishlist-img-wrapper">
                      {hasDiscount && <span className="wishlist-badge">Sale</span>}
                      <img
                        src={item.productImage || 'https://placehold.co/300x220/E9ECEF/333?text=Product'}
                        className="card-img-top"
                        alt={item.product_name}
                        onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/300x220/E9ECEF/333?text=No+Image"; }}
                      />
                    </Link>

                    <div className="card-body">
                      <Link to={`/product_details/${item.product_id || item.id}`} className="text-decoration-none">
                        <h5 className="card-title">{item.product_name}</h5>
                      </Link>

                      <div className="wishlist-price-section">
                        {hasDiscount && (
                          <span className="original-price text-decoration-line-through">
                            £{regularPrice.toFixed(2)}
                          </span>
                        )}
                        <span className="discounted-price">
                          £{discountPrice.toFixed(2)}
                        </span>
                      </div>

                      <div className="wishlist-actions mt-auto">
                        <Link
                          to={`/product_details/${item.product_id || item.id}`}
                          className="btn-wishlist-main btn-details-wishlist text-decoration-none"
                        >
                          <FaEye /> View
                        </Link>
                        <button
                          onClick={() => handleAddToCartAndRemove(item)}
                          className="btn-wishlist-main btn-addtocart-wishlist"
                        >
                          <FaCartPlus /> Buy
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default WishListPage;
